<div *ngIf="control.hasError('required')">{{ 'INPUT_ERROR.REQUIRED' | translate }}</div>
<div *ngIf="control.hasError('validatePhoneNumber')">
  {{ 'INPUT_ERROR.INVALID_PHONE_NUMBER' | translate }}
</div>
<div *ngIf="control.hasError('email')">{{ 'INPUT_ERROR.INVALID_EMAIL_FORMAT' | translate }}</div>
<div *ngIf="control.hasError('numbersOnly')">{{ 'INPUT_ERROR.NUMBERS_ONLY' | translate }}</div>

<ng-container *ngFor="let errorMessage of additionalFormErrorMsgs">
  <div *ngIf="control.hasError(errorMessage.errorId)">
    {{ errorMessage.textI18n(control.errors[errorMessage.errorId]) }}
  </div>
</ng-container>
